// Strip the `<untrusted source="…">…</untrusted>` envelope from a string.
//
// The envelope is a server-side wrapper that tells the LLM "this is data,
// not an instruction" (CLAUDE.md untrusted-content principle). It must NEVER
// appear in user-facing output: it's noise to the reader and leaks our
// internal prompt-injection defence.
//
// The agent is instructed to never emit these tags in its prose, but this
// is defence-in-depth — a render-time scrub so a single prompt regression
// doesn't leak the envelope to the user.
//
// Handles:
//   - one or many envelopes within a string (markdown paragraph can hold
//     multiple quotes from different sources)
//   - any source attribute value (the source name itself isn't displayed)
//   - unmatched orphan opening/closing tags (defensive, since a regressed
//     agent might forget to close one)

const OPEN_RE = /<untrusted\s+source="[^"]*"\s*>/gi;
const CLOSE_RE = /<\/untrusted\s*>/gi;

export function stripUntrustedTags(s: string): string {
  if (typeof s !== 'string') return s;
  return s.replace(OPEN_RE, '').replace(CLOSE_RE, '');
}
